export default __webpack_public_path__ + "static/media/Route_Filled_Active.c16d5f4f.svg";